/**
 * RBAC Permission Constants for PUMA
 * Centralized permission definitions for role-based access control
 * Following the same pattern as other core constants (Country, Locale, etc.)
 */
export const PERMISSIONS = {
    ADMIN: 'Admin',
    CATEGORY_JOBS: 'Category-Job-Users',
    PROMO_JOBS: 'Promo-Name-Job-Users',
    BULK_PROMO: 'Bulk-Promo-Users',
} as const;

// Page titles for AccessDenied components
export const PAGE_TITLES = {
    CATEGORY_JOBS: 'Category Job Management',
    PROMO_JOBS: 'Promotion Offer Assignment',
    BULK_PROMO: 'Bulk Promo Job Management',
    SHOP_CATEGORY: 'Shop Category Definitions',
} as const;
